export default __webpack_public_path__ + "static/media/whiskeybackground2.97ceba6c.jpg";